// Pricing Data Version core
export function pricingDataVersionCore() {
    const endpoint = '/saleschannels/pricingversioning';

    return {
      endpoint
    };
  }

  // Pricing Data Version  filter
  export function pricingDataVersionFilter() {
    // Get rows
    const getRows = (data) => {
      const rows = [];

      data.forEach((row, i) => {
        // Text/numeric values
        rows[i] = {
          value: row,
          label: parseFloat(row).toFixed(1)
        };
      });

      return rows;
    };

    return {
      getRows: getRows
    };
  }
